export { default as CoreTabs } from './module';
export * from './components/';
